export default __webpack_public_path__ + "static/media/17.1b856f4e.jpg";